<style lang="less" scoped>
  @import "../../assets/colorTheme";
  .el-card{
    .el-card__header{
      i{color: @mainColor; font-size: 20px; margin-right: 10px;}
    }
  }
</style>

<template>
  <div style="margin-bottom: 20px">
    <el-row :gutter="20">
      <el-col :span="7">
        <el-card>
          <div slot="header" class="clearfix">
            <span><i class="iconfont icon-similar-stastic"></i> 总览</span>
          </div>
          <overview-chart v-if="overviewData" :chart-data="overviewData"></overview-chart>
        </el-card>
      </el-col>
      <el-col :span="7">
        <el-card>
          <div slot="header" class="clearfix">
            <span><i class="iconfont icon-distribute"></i> 有效对比置信度分布</span>
          </div>
          <match-chart v-if="matchData" :chart-data="matchData"></match-chart>
        </el-card>
      </el-col>
      <el-col :span="10">
        <el-card>
          <div slot="header" class="clearfix">
            <span><i class="iconfont icon-retry-stastic"></i> 近十二月使用统计</span>
          </div>
          <twelve-month v-if="twelveMonthData" :chart-data="twelveMonthData"></twelve-month>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapCompute, mapSetIfAbsent } from '../../utils'
  import overviewChart from "./overview"
  import twelveMonth from "./twelveMonth"
  import matchChart from "./match"

  const compareIsPositive = (e) => e.result.match >= e.result.threshold;

  export default {
    components: {
      overviewChart,
      matchChart,
      twelveMonth
    },
    props: {
      dataList: {
        type: Object,
        required: true
      }
    },
    watch: {
      dataList(v){
        this.loadOverview(v);
        this.loadTwelveMonth(v);
        this.loadMatch(v);
      }
    },
    data() {
      return {
        overviewData: null,
        twelveMonthData: null,
        matchData: null
      }
    },
    methods: {
      loadOverview(records) {
        const backgroundColor = [
          'rgba(87, 190, 198, 1)',
          'rgba(235, 69, 137, 1)',
          'rgba(63, 145, 247, 1)',
          'rgba(250, 228, 102, 1)',

        ]

        this.overviewData = {
          labels: ['相似', '不相似', '对比异常'],
          datasets: [{
            data: [records.successCount, records.failCount, records.exceptCount],
            backgroundColor: backgroundColor,
          }]
        }
      },
      loadTwelveMonth(records){
        let lastTenMonths = [];
        if(records.ipListCount) {
          lastTenMonths = records.ipListCount.length > 10 ? records.ipListCount.slice(records.ipListCount.length - 12) : records.ipListCount
        }
        this.twelveMonthData = {
          labels: lastTenMonths.map(e => e.dates),
          datasets: [{
            data: lastTenMonths.map(e => e.count),
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(148, 193, 251, 0.2)',
              'rgba(111, 172, 251, 0.2)',
              'rgba(63, 144, 247, .2)',
              'rgba(157, 223, 226, 0.2)',
              'rgba(132, 222, 226, 0.2)',
              'rgba(88, 192, 197, 0.2)',
              'rgba(91, 200, 247, 0.2)',
            ],
            borderColor: [
              'rgba(255,99,132,1)',
              'rgba(255, 159, 64, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(148, 193, 251, 1)',
              'rgba(111, 172, 251, 1)',
              'rgba(63, 144, 247, 1)',
              'rgba(157, 223, 226, 1)',
              'rgba(132, 222, 226, 1)',
              'rgba(88, 192, 197, 1)',
              'rgba(91, 200, 247, 1)',
            ],
            borderWidth: 1
          }],
        }
      },
      loadMatch(records){
        let arr = [];
        if (records.matchScore) {
          for (let [k, v] of Object.entries(records.matchScore)) {
            arr.push(v)
          }
        };
        this.matchData = {
          labels: (new Array(10).fill(0)).map((e, i) => `${i / 10} ~ ${(i + 1) / 10}`),
          datasets: [{
            label: '1vs1 置信度分布',
            data: arr,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(148, 193, 251, 0.2)',
              'rgba(111, 172, 251, 0.2)',
              'rgba(63, 144, 247, .2)',
              'rgba(157, 223, 226, 0.2)',
              'rgba(132, 222, 226, 0.2)',
              'rgba(88, 192, 197, 0.2)',
              'rgba(91, 200, 247, 0.2)',
            ],
            borderColor: [
              'rgba(255,99,132,1)',
              'rgba(255, 159, 64, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(148, 193, 251, 1)',
              'rgba(111, 172, 251, 1)',
              'rgba(63, 144, 247, 1)',
              'rgba(157, 223, 226, 1)',
              'rgba(132, 222, 226, 1)',
              'rgba(88, 192, 197, 1)',
              'rgba(91, 200, 247, 1)',
            ],
            borderWidth: 1
          }]
        }
      }
    },
    mounted() {
      this.loadOverview(this.dataList);
      this.loadTwelveMonth(this.dataList);
      this.loadMatch(this.dataList);
    }
  }
</script>
